import { css } from 'styled-components';

export const sizes = {
    giantXl: 1440,
    giant: 1366,
    desktop: 1024,
    desktopLegacy: 1240,
    tablet: 768,
    tabletLegacy: 801, // remove after mergin all styles from UI repo
    tabletSm: 480,
    phone: 320
};

export const media = Object.keys(sizes).reduce((acc, label) => {

    acc[label] = (literals: TemplateStringsArray, ...placeholders: any[]) => css`
    @media(min-width: ${sizes[label]}px) {
        ${css(literals, ...placeholders)}
    }`;
    return acc;
}, {} as Record<keyof typeof sizes, (l: TemplateStringsArray, ...p: any[]) => string>);
